import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.8, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const LineReveal = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.95, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const FadeIn = ({ children, delay = 0, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const Editable = () => (
    <span
        data-testid="editable-badge"
        className="ml-2 inline-block rounded-full border border-dashed border-terracotta/60 px-2 py-0.5 align-middle text-[10px] font-semibold uppercase tracking-wider text-terracotta"
        title="Contenido provisional editable"
    >
        editable
    </span>
);
